import { useState } from "react"
import { useTranslation } from "react-i18next"
import Profile from "./components/Profile/Profile"
import Security from "./components/Profile/Security"
import Verification from "./components/Profile/Verification"
import Referral from "./components/Profile/Referral"
import Settings from "./components/Profile/Settings"
import "./style/ProfileIndex.scss"

const TABS = ["profile", "security", "verification", "referral", "settings"] as const

const ProfileIndex = () => {
  const [tab, setTab] = useState<(typeof TABS)[number]>("profile")
  const { t } = useTranslation()

  return (
    <div className="profile-layout">
      <aside className="profile-sidebar">
        <ul>
          {TABS.map(tKey => (
            <li
              key={tKey}
              className={tab === tKey ? "active" : ""}
              onClick={() => setTab(tKey)}
            >
              {t(`profileTabs.${tKey}`)}
            </li>
          ))}
        </ul>
      </aside>

      <section className="profile-content">
        {tab === "profile" && <Profile />}
        {tab === "security" && <Security />}
        {tab === "verification" && <Verification />}
        {tab === "referral" && <Referral />}
        {tab === "settings" && <Settings />}
      </section>
    </div>
  )
}

export default ProfileIndex
